export const SERVICE_CHASE_COVER_REPLACE = {
  label: 'Replace Chase Cover',
  value: 'SERVICE_CHASE_COVER_REPLACE'
};
export const SERVICE_TRIM_REPLACE = {
  label: 'Replace Trim',
  value: 'SERVICE_TRIM_REPLACE'
};
